/* Auto Infinite Scroll - Authentic Marina */
(function() {
  'use strict';

  var isLoading = false;
  var observer = null;

  function setupObserver() {
    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !isLoading) {
          isLoading = true;
          entry.target.click();
          setTimeout(function() {
            isLoading = false;
            watchForButton();
          }, 2500);
        }
      });
    }, {
      rootMargin: '400px 0px'
    });

    watchForButton();
  }

  function watchForButton() {
    var btn = document.querySelector('.ias-trigger');
    if (btn && btn.offsetParent !== null) {
      observer.observe(btn);
      return;
    }

    // Also try .load-more as fallback
    var btn2 = document.querySelector('.load-more');
    if (btn2 && btn2.offsetParent !== null) {
      var clickTarget = btn2.closest('.ias-trigger') || btn2;
      observer.observe(clickTarget);
      return;
    }

    // Button not found yet, retry
    setTimeout(watchForButton, 500);
  }

  // Also watch for DOM changes (new buttons appearing after load)
  var mutationObs = new MutationObserver(function() {
    if (!isLoading) {
      watchForButton();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupObserver();
      mutationObs.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    setupObserver();
    mutationObs.observe(document.body, { childList: true, subtree: true });
  }
})();